import { Stack, UnstyledButton, Group, Avatar, Text } from "@mantine/core";
import { useNavigate, useLocation } from "react-router-dom";
import { Logo } from "../../lib/data";
import { routes } from "../../lib/routes";
import "./styles.scss";

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem("t");
    navigate("/login");
  };

  return (
    <aside className="sidebar">
      <Stack gap="xl" className="sidebar-content">
        {/* Logo Section */}
        <Group className="sidebar-logo" gap="sm">
          <img src={Logo} alt="Ufamilymedicine Logo" />
        </Group>

        {/* Navigation */}
        <nav className="sidebar-nav">
          <Stack gap={4}>
            {routes.map((route) => {
              const Icon = route.icon;
              const isActive = location.pathname === route.path;

              return (
                <UnstyledButton
                  key={route.path}
                  onClick={() => navigate(route.path)}
                  className={`sidebar-link ${isActive ? "active" : ""}`}
                >
                  <Group gap="sm">
                    <Icon size={20} stroke={1.5} />
                    <span>{route.label}</span>
                  </Group>
                </UnstyledButton>
              );
            })}
          </Stack>
        </nav>

        {/* Profile + Logout */}
        <div className="sidebar-footer">
          <UnstyledButton
            onClick={() => navigate("/d/profile")}
            className="sidebar-link sidebar-profile"
          >
            <Group gap="sm">
              <Avatar size={28} radius="xl" color="teal">
                P
              </Avatar>
              <span>Profile</span>
            </Group>
          </UnstyledButton>

          <UnstyledButton
            onClick={handleLogout}
            className="sidebar-link sidebar-logout"
          >
            <Group gap="sm">
              <span>Logout</span>
            </Group>
          </UnstyledButton>
        </div>
      </Stack>
    </aside>
  );
};

export default Sidebar;
